/**
 * KIRILIM VE YERLEŞİM KATMANI — Revizyon 2 sözleşmesi.
 * Kaynak: `docs/tasarim-kirilim-sozlesmesi.md` (tasarım dosyasının kendi
 * `script` bloğundan çıkarılmış değerler; yorumlanmadı).
 *
 * `tokens.ts`ten AYRI dosyadır (borç bölme — `docs/faz-4-backlog.md` md. 13.6):
 * renk/tipografi ölçeğiyle kırılım aritmetiği farklı hızlarda değişir ve tek
 * dosyada tutmak dosya tavanını sürekli zorluyordu.
 */
/**
 * BEŞ KIRILIM — Revizyon 2 sözleşmesi (`docs/tasarim-kirilim-sozlesmesi.md` §2).
 * Değerler tasarım dosyasının `bpOf(w)` fonksiyonundan birebir alındı.
 *
 * Kırılım TEK KAYNAKTIR: web'deki her kabuk medya sorgusu (ray · dolgu ·
 * kolon arası · yan menü/detay kolonu) bu eşiklerden üretilir. Modülde
 * ara eşik (860 · 900 · 1100 gibi) tanımlanmaz.
 */
export const breakpoints = {
    /** < 768 — çekmece menü, detay ayrı sayfa. */
    sm: 0,
    md: 768,
    l: 1024,
    xl: 1280,
    xxl: 1536,
};
/**
 * IZGARA SÖZLEŞMESİ — Revizyon 2 §3. Eşik EKRANA DEĞİL ORTA KOLONA bağlıdır
 * ve kod tarafında `@container (min-width: 760px)` ile kurulur; tasarımcı
 * medya sorgusunu açıkça reddetti (1536'da orta kolon 494'e düşüp eşiği
 * kırıyordu).
 */
export const grid = {
    /** GRID_MIN — orta kolon bu değeri geçince ızgara açılır. */
    min: 760,
    /** CARD_MIN — ızgara kartı asgari genişliği. */
    cardMin: 340,
    /** CARD_GAP — ızgara kartları arası. */
    cardGap: 16,
    /** GRID_MAX — en çok iki kolon. KURALIN KENDİSİ, hesaptan türetilmez. */
    max: 2,
    /** MID_MIN — orta kolonun bağlayıcı tabanı. Altına düşen değişiklik gönderilmez. */
    midMin: 510,
};
/** Tasarım dosyasının `kolonSayisi(mid)` fonksiyonu — kanıt ve testte kullanılır. */
export function gridColumnsFor(midWidth) {
    if (midWidth < grid.min)
        return 1;
    const fits = Math.floor((midWidth + grid.cardGap) / (grid.cardMin + grid.cardGap));
    return Math.min(grid.max, Math.max(1, fits));
}
/**
 * IZGARA TAVANI İSTİSNALARI — beyanlı ve gerekçeli
 * (`docs/anasayfa-izgara-karari-2026-09-06.md`, kullanıcı kararı).
 *
 * `grid.max = 2` Revizyon 2 sözleşmesidir ve 30 yüzeye bağlıdır; sözleşme genel
 * olarak 2'de KALIR. Burada yalnız TEK TEK yüzeyler için, referansın kendi
 * ızgarasına dayanan istisnalar yazılır. İstisna `ListSurface`e
 * `gridException` ile bildirilir; kural `layoutLadderCssVariables()` içinde
 * `[data-grid-exception]` seçicisiyle üretilir — modülde elle kolon yazılmaz.
 *
 * Her istisna:
 *   · `max`         o yüzeyin kolon tavanı. `grid.max`tan BÜYÜK olmak
 *                   zorundadır — değilse istisna değildir ve kapı KIRILIR
 *                   (`list-anatomy.guard.spec`: kolon sayısı geri alınırsa
 *                   test düşer, istisna sessizce sözleşmeye dönmez).
 *   · `cardMin`     referansın `minmax(<cardMin>, 1fr)` alt sınırı. Kolon
 *                   sayısı yine `kolonSayisi()` aritmetiğidir
 *                   (`gridExceptionColumnsFor`); tavana ulaşma eşiği buradan
 *                   türer, icat edilmez.
 *   · `fit`         `auto`: referansın `auto-fit`i — boş ray kapanır,
 *                   kartlar yayılır; tavan yine `max`tır (`minmax(max(cardMin,
 *                   %/max), 1fr)`), tavansız değildir. `fixed` (tavana ulaşan
 *                   konteynerde her zaman `max` ray, az kartta raylar BOŞ
 *                   KALIR) 06.09'da karar belgesiyle geri alındı ve dalı
 *                   SİLİNDİ (27. kaçamak turu, tech-lead §4 (b)): CSS üretimi,
 *                   kapı ve ölçer artık yalnız `auto` bilir. Tip literal
 *                   `'auto'`dur; `fixed` gerekirse tip bilinçli genişletilir ve
 *                   üç tüketici birlikte yeniden yazılır — ölü dal tutulmaz.
 *                   `ana-sayfa-kolon-bosluk.spec` ince dalı boş rayı 0 ölçer,
 *                   `list-anatomy.guard` `fit`i pinler.
 *                   `fill` (14.10.2026, organizatör sayfası QA P2-2): referansın
 *                   SABİT raylı `repeat(3, minmax(0,1fr))`i — `auto-fill`, boş
 *                   ray kapanmaz, tek kalan kart YAYILMAZ (öksüz satır kuralı
 *                   `grid.min`den itibaren geri alınır). Kart sayısı ne olursa
 *                   olsun kart bir kolon genişliğindedir. Her literal en az bir
 *                   kayıtta kullanılır (`GRID_EXCEPTION_FITS`, kapı bayatlığı
 *                   ölçer); ölü dal tutulmaz.
 *   · `coverHeight` kapak SABİT yüksekliği (referans `height:150px`); `null`
 *                   ise anatominin kendi 16:9'u kalır.
 *   · `why`         gerekçe — kapı uzunluğunu asertler, boş bırakılamaz.
 *
 * BAYATLIK: her anahtar depoda en az bir `gridException="<anahtar>"` ile
 * KULLANILMAK zorundadır; kullanılmayan istisna kapıyı kırar. Yeni bir
 * istisna eklemek bu kayda yazmayı VE gerekçeyi gerektirir.
 */
export const GRID_EXCEPTION_FITS = ['auto', 'fill'];
export const gridExceptions = {
    /**
     * Kişisel ana sayfa · "Sana önerilen etkinlikler" — Yön B referansı
     * `repeat(auto-fit, minmax(320px, 1fr))` + `height:150px` kapak. Ray kalkıp
     * akış 1116 px'e çıkınca `grid.max = 2` üçüncü kartı öksüz satıra atıyor ve
     * 16:9 kapağı 313 px'e şişiriyordu (tech-lead O7, ölçüldü).
     *
     * `fit` ÖNCE `fixed` idi (ızgara düzeltme turu): gerekçesi "tek öneri
     * yayılırsa kapak şişer" idi; `coverHeight: 150` çivilenince gerekçe
     * ortadan kalktı ve geriye 1116 px akışta tek önerinin sağında **754,67 px
     * boş ray** kaldı (ölü boşluk tavanı 56'nın on üç katı; komşu kişi ızgarası
     * aynı girdiyle zıt davranıyordu). `auto`ya döndü — ÖLÇÜLDÜ (ince dal,
     * 1116 px): kart 1116 × 367,47 · kapak 150 (şişmiyor) · boş ray 0; dolu
     * dal değişmedi (3 × 361,33 · kapak 150 · öksüz yok). Karar:
     * `docs/anasayfa-izgara-karari-2026-09-06.md` → "`fit: 'auto'` kararı".
     */
    homeRecommendedEvents: {
        max: 3,
        /*
         * `cardMin` REFERANSIN 320'Sİ DEĞİL, 300 (QA P2-2, 06.09). 320 ile üçüncü
         * ray 992 px konteynerde açılıyordu; 1024 px ekranda akış 949 px'tir ve
         * ızgara 2 rayda kalıp üçüncü kartı 949 px'lik öksüz satıra yayıyor,
         * 150 px'e çivili kapağı 6,36:1 banda çeviriyordu (ölçüldü). 300 ile
         * üçüncü ray 932 px'te açılır: 1024'te 3 × 305,67 (kapak 2,04:1).
         * 300, kartın 375 px ekranda ZATEN ölçülmüş enidir (tek kolon: 300 px);
         * daha dar bir kart üretilmez. 1280–1536 değişmez (3 × 361,33 · 1134'te
         * 3 × 367,36) — orada `(100% − 32) / 3` zaten 300'ün üstündedir.
         */
        cardMin: 300,
        fit: 'auto',
        coverHeight: 150,
        why: 'Yön B referansı 3 kolon + 150 px sabit kapak; raysız akışta 2 kolon öksüz satır ve 313 px kapak üretiyordu (O7). auto: referansın auto-fit’i — tek/iki öneride kart yayılır, kapak 150’de çivili kaldığı için şişmez; fixed’in 754,67 px boş rayı kullanıcının whitespace kuralıyla çelişiyordu (ölçüldü: auto’da boş ray 0, kapak 150). cardMin 300 (referans 320): 1024 px ekranda 949 px akış üçüncü rayı açsın diye — 320 ile üçüncü kart 949 px öksüz satıra yayılıp kapağı 6,36:1 banda çeviriyordu (QA P2-2, ölçüldü); 300 kartın 375 px ekrandaki ölçülmüş enidir.',
    },
    /**
     * Kişisel ana sayfa · "Tanışabileceğin kişiler" — referans
     * `repeat(auto-fit, minmax(260px, 1fr))`: kapaksız kişi kartı dardır, boş
     * ray kapanır. İki kolonda üçüncü kart 1116 px'lik öksüz satıra düşüyordu.
     *
     * `cardMin` REFERANSIN 260'I DEĞİL, SÖZLEŞMENİN `CARD_MIN`İDİR (340).
     * Referansın kişi kartı CTA'yı `ReasonBlock`un ALTINA koyar
     * (`anasayfa-uc-yon.dc.html:338-354`) ve 260'a sığar; bizim kart eylemleri
     * (Görüşme iste + ⋯) AD SATIRINA koyar — 260 ile 1024'te üç ray açılıp
     * kart 305 px'e iniyor, rol satırı beş parçaya bölünüyor ve ayraç "·"
     * tek başına kalıyordu (tech-lead ızgara incelemesi, ÖLÇÜLDÜ). 340 ile
     * 1116 px'te yine 3 × 361,33 (değişmez), 949 px'te 2 × 466,5.
     */
    homeRecommendedPeople: {
        max: 4,
        cardMin: grid.cardMin,
        fit: 'auto',
        coverHeight: null,
        why: 'Referans kişi ızgarası auto-fit; iki kolonda üçüncü kişi kartı 1116 px öksüz satıra düşüyordu (O7). Asgari sözleşmenin CARD_MIN 340 değeridir: eylemleri ad satırında taşıyan kart 260 ile 1024 px ekranda 305 px’e inip rol satırını parçalıyordu.',
    },
    /**
     * Organizatör sayfası · §2 "Yaklaşan etkinlikler" (13.10.2026 tasarım,
     * `docs/design/organizator-sayfasi/`). Referans 1440'ta `repeat(3, minmax(0,
     * 1fr))` + 150 px kapak çizer ve kararlar tablosu "768 ve 1024'te ızgara 2
     * kolona iner, 640 altında tek kolon" der. Akış genişliği ana sayfa önerileriyle
     * aynı (public ray), bu yüzden eşik ve kapak o istisnanın ölçülmüş değerleridir.
     */
    organizerUpcomingEvents: {
        max: 3,
        /*
         * 320 (ölçüldü, 14.10.2026): 300 ile 1024 px ekranda akış 960 px'te ÜÇÜNCÜ ray
         * açılıyordu; kararlar tablosu 1024'te İKİ kolon ister. 320 ile üçüncü ray
         * 992 px konteynerde açılır: 1024'te 2, 1280 ve 1440'ta 3 kolon.
         */
        cardMin: 320,
        /*
         * `fill` (QA P2-2, 14.10.2026): `auto` ile 1440'ta öne çıkan + 1 etkinlikte
         * kolonlar `1116px 0px 0px` ölçüldü (boş ray kapandı, tek kart 1116 × 150
         * bant) ve 1024'te tek kalan son kart iki kolonu kapladı. Referansın rayları
         * sabittir: kart her zaman bir kolon genişliğindedir.
         */
        fit: 'fill',
        coverHeight: 150,
        why: 'Organizatör sayfası referansı 1440’ta 3 kolon ve 150 px kapak çizer; kararlar tablosu 1024’te 2 kolon ister. grid.max = 2 ile üçüncü kart öksüz satıra düşerdi. cardMin 320: 1024 px ekranda 960 px akışta 2, 1280/1440’ta 3 kolon (ölçüldü). fill: referansın rayları sabit, az kartta boş ray kalır ve tek kalan kart yayılmaz (QA P2-2). 768’de akış 704 px ve sözleşmenin GRID_MIN 760 eşiğinin altındadır, ızgara tek kolon kalır (referanstaki 2 kolonun sistem sözleşmesiyle sapması, raporda).',
    },
};
/**
 * Ana sayfa öneri kartının MOBİL kapak yüksekliği — `MOBİL B` artboard'u
 * (`anasayfa-uc-yon.dc.html`, "Size önerilen" kartı: `height:132px`, viewBox
 * 358×132). Web ayağı bölüm 03'ün masaüstü ızgarasından 150 alır
 * (`gridExceptions.homeRecommendedEvents.coverHeight`); mobil artboard aynı
 * kartı 132 çizer. Ortak `EventStackCard` anatomisi (16:9) 390 dp'de ~201 dp
 * kapak üretiyor ve ilk kartın baş harfi, adı ve gerekçesi katlamanın altında
 * kalıyordu (QA P2-2, ölçüldü: kart üstü 623,3 dp · katlama 764 dp). Kapak
 * ana ekran varyantında bu sayıya çivilenir; keşif ve öneri ekranları 16:9'da
 * kalır. `home-top-geometry.guard` bu sayıyı referanstan okuyup ölçer.
 */
export const HOME_RECOMMENDED_COVER_HEIGHT_MOBILE = 132;
/**
 * İstisnalı yüzeyin RAY SAYISI: `kolonSayisi()` ile aynı aritmetik, tavan ve
 * asgari kart yüzeyin kendisinden. `auto`da ekrandaki kolon sayısı ayrıca
 * kart sayısıyla sınırlıdır (`min(ray, kart)`); `fill`de raylar boş kalır.
 */
export function gridExceptionColumnsFor(key, midWidth) {
    const rule = gridExceptions[key];
    if (midWidth < grid.min)
        return 1;
    const fits = Math.floor((midWidth + grid.cardGap) / (rule.cardMin + grid.cardGap));
    return Math.min(rule.max, Math.max(1, fits));
}
/**
 * İstisnanın `columns` raya ulaştığı en dar konteyner (k × cardMin +
 * (k − 1) × gap, en az `grid.min`). Öksüz sıfırlamasının konteyner eşiği ve
 * kapının beklentisi AYNI fonksiyondan okur — iki yerde iki aritmetik olmaz.
 */
export function gridExceptionThresholdFor(key, columns) {
    const rule = gridExceptions[key];
    return Math.max(grid.min, columns * rule.cardMin + (columns - 1) * grid.cardGap);
}
/**
 * Metin kutuları için sabit genişlik YASAK (README 4.9):
 * min/max çifti kullanılır ki %30–%160 uzayan çeviri taşma yapmasın.
 */
export const layout = {
    contentMinWidth: 280,
    /**
     * ÜÇ RAY — devir paketi README §4.0 "Kabuk kuralı" (bağlayıcı sözleşme).
     * Sayfa kendi kabını TANIMLAMAZ; `PageShell` bu üç değerden birini uygular.
     * Eski `contentMaxWidth` / `appMaxWidth` / `appShellGutter` üçlüsü kalktı:
     * 30 yüzey kendi kabını ayrı ayrı tanımladığı için raylar ayrışmıştı.
     */
    /**
     * RAYLAR — Revizyon 2 (`railOf(w)`). **WEB BU DEĞERLERİ OKUMAZ** (yeni
     * görünüm R turu, 29.10.2026): web rayları `web-tema/yerlesim.ts`tedir
     * (`webRails`, 1424). Buradaki değerler mobil temasının parmak izinde
     * (M-1) ve yönetim panelinin ray profilinde (`railProfiles.admin`) donmuştur.
     *
     * `app` xl'e kadar 1180'de SABİT durur, artan genişlik ZEMİNE gider
     * (1512'de içerik kenardan 198 px içeride). **xxl'de (≥1536) ray büyür:**
     * `min(78vw, 1760)`. 78vw 1536'da 1198 verir — xl'in 1180'inin hemen üstü,
     * geçiş sıçramasız; 1760 tavanı satır/tablo okunurluğunun üst sınırıdır.
     *
     * Birinci revizyonun "1180 SABİT, oranlı ray geri alındı" gerekçesi
     * (kartlar uzar, sayı artmaz) Revizyon 2'de ÇÖZÜLDÜ: yığın listeleri artık
     * orta kolon 760'ı geçince ızgaraya açılıyor — kart sayısı artıyor, kart
     * uzamıyor. Bu yüzden ray xxl'de büyüyebilir.
     *
     * `reading` ve `public` BÜYÜMEZ (Revizyon 2 §5 "değişmeyenler"): ikisi de
     * satır uzunluğuyla sınırlıdır.
     */
    rails: {
        /**
         * Veri yoğun her yüzey (organizatör paneli · admin · keşif · katılımcı
         * dizini · kişisel ana sayfa · Yönettiklerim · talepler · cüzdan).
         * Üç kolon kontrolü (xl): 1180 − 2×32 (dolgu) − 220 (yan menü) − 320
         * (detay) − 2×24 (kolon arası) = 528 (eşik 510). Detay kolonu YALNIZCA
         * xl ve xxl'de ızgaradadır; `l`de üst katmana çıkar, yoksa orta kolon
         * 1100 px ekranda 448'e düşer ve 510 eşiğini kırardı.
         */
        app: 1180,
        /**
         * Tek sütunlu okuma/form yüzeyi. Uygulama rayının İÇİNDE durur ve SOLA
         * yaslıdır — ortalamak, yan menülü ekranlardan geçişte içeriği yatay
         * olarak zıplatıyordu (README §4.0).
         *
         * 880 SABİT: metin yüzeyidir (Ajandam · ayarlar · profil kurulumu) ve 80
         * karakteri aşan satır okunabilirliği düşürür. Tasarımcı Ajandam'ı tam bu
         * nedenle 920'den 880'e indirmişti (devir paketi sapma listesi #4).
         */
        reading: 880,
        /** Public etkinlik/konuşmacı sayfası, kartvizit paylaşımı, landing. */
        public: 1180,
    },
    /**
     * UYGULAMA RAYININ xxl BASAMAĞI — `railOf(w)`in `min(round(w*0.78), 1760)`
     * dalı. CSS'te `min(78vw, 1760px)` olarak basılır; medya sorgusunun eşiği
     * `breakpoints.xxl`dir.
     */
    railWide: {
        minWidth: breakpoints.xxl,
        vw: 78,
        maxPx: 1760,
    },
    /**
     * KOLON ÖNCELİKLİ TABLO — yönetim paneli listeleri (satış adayları, kurumlar,
     * kredi defteri). Referans: "dar ekranda yatay kaydırma yerine düşük öncelikli
     * kolonlar gizlenir". Eşik EKRANA DEĞİL TABLONUN KABINA bağlıdır ve
     * `@container` ile kurulur (ızgara sözleşmesiyle aynı gerekçe): ray xxl'de
     * `78vw` ile büyüdüğü için 1536 ekran eşiği sekiz kolonu 888 px alanda açıyor
     * ve tabloyu 1090 px ile taşırıp yatay kaydırma üretiyordu (tech-lead T4,
     * 1536 ve 1680'de ölçüldü). 1100 = en geniş tablonun (satış adayları, sekiz
     * kolon) doğal genişliği 1090 + pay.
     */
    priorityTable: {
        min: 1100,
    },
    /**
     * İÇERİK SÜTUNLARI — ray DEĞİL. Ray sayfanın kabıdır; sütun o kabın içindeki
     * bir kolondur. Sözleşme sütun kavramını zaten kullanıyor (220 yan menü,
     * 240 ayarlar menüsü, 320 detay paneli); bunlar da onlardan biridir.
     *
     * Ray akışkan olsa da sütunlar SABİTTİR: kazanılan genişlik orta kolona
     * gider (ürün sahibi kararı 2026-08-27).
     */
    columns: {
        /**
         * Davet ve başvuru ekranlarının dar künye sütunu (§8.4 #29/#30 — "ray
         * okuma rayı AMA dar sütun ray içinde kalır"). Okuma rayı gibi SOLA yaslı.
         */
        narrow: 640,
        /**
         * Sağ detay/sinyal kolonu (kişi paneli · öneri sinyalleri · kayıt kutusu ·
         * cüzdan notu). 344 → 320: ray 1180'e inince orta kolonun 510 eşiğini
         * koruması için yan kolonlar daraldı.
         */
        detail: 320,
        /**
         * KATILIMCI DİZİNİNİN İKİ YAN KOLONU — tasarımın kendi daralttığı ölçüler
         * (`docs/design/katilimci-dizini/…dc.html` §05 "Kırılım sözleşmesi":
         * `F_RAIL = 224`, `D_RAIL = 304`).
         *
         * Dizin, kabuğun TEK ekranıdır ki aynı anda ÜÇ kolon taşır ve ortadaki
         * kolon bir TARAMA yüzeyidir: satırda ad, unvan·şirket ve gerekçe yan yana
         * değil ALT ALTA durur, yani orta kolonun eni doğrudan unvanın kaç satıra
         * yayıldığını belirler. Genel `sideNavWidth` (220) + `columns.detail` (320)
         * çiftiyle orta kolon 528 px kalıyor; tasarımın 224/304 çiftiyle 540 px
         * olur ve 510 tabanına 30 px pay bırakır.
         *
         * Genel sözleşme DEĞİŞTİRİLMEDİ (13 yüzey ona bağlı); bu iki sayı yalnız
         * dizinin ızgarasına girer ve `attendeeDirectoryMidWidth()` ile ölçülür.
         */
        directoryFilter: 224,
        directoryDetail: 304,
    },
    /**
     * Yan dolgu merdiveni — rayın İÇİNDE (`max-width` ray, `padding-inline`
     * merdiven). Revizyon 2 `padOf(w)`: sm 16 · md 24 · l/xl/xxl 32.
     *
     * 48 ve 64 basamakları KALKTI: geniş ekranda boşluk artık dolgudan değil
     * ZEMİNDEN geliyor. xl ve xxl için ayrı basamak YOK — `padOf` üçünde de 32
     * döndürüyor; tekrarlanan basamak sözleşmeye gürültü ekler.
     */
    gutterLadder: [
        { minWidth: breakpoints.sm, padding: 16 },
        { minWidth: breakpoints.md, padding: 24 },
        { minWidth: breakpoints.l, padding: 32 },
    ],
    /**
     * KOLON ARASI merdiveni — Revizyon 2 `gapOf(w)`: sm/md 16 · l/xl/xxl 24.
     * Kabuk ızgaralarının `gap`i buradan gelir (`--ib-gap`); `rhythm.columnGap`
     * merdivenin üst basamağıdır ve geriye dönük uyum için duruyor.
     */
    gapLadder: [
        { minWidth: breakpoints.sm, gap: 16 },
        { minWidth: breakpoints.l, gap: 24 },
    ],
    /**
     * İç ritim (README §4.0 "İç ritim"). Mobilde kart arası AZALIR: 375'te
     * boşluğu büyütmek ekrana giren satırı azaltıp kaydırmayı uzatıyordu.
     */
    rhythm: {
        cardGapDesktop: 24,
        cardGapMobile: 12,
        tableRowPadding: 16,
        cardPadding: 20,
        sectionGap: 48,
        /** 32 → 24 (ray 1180'e inince orta kolon eşiği korunsun diye). */
        columnGap: 24,
        headingToContent: 24,
        /**
         * Uygulama kabuğunun yan menüsü (organizatör paneli · kurum ayarları ·
         * keşif filtresi · dizin filtresi). 232 → 220, aynı gerekçe.
         */
        sideNavWidth: 220,
    },
    /**
     * Ayarlar yan menüsü. Referans `Giriş, Profil Kurulumu ve Ayarlar` →
     * `webSettings` ızgarası `240px minmax(0,1fr)`; kabuk artık okuma rayıdır.
     */
    settingsNavWidth: 240,
    textBlockMinWidth: 160,
    textBlockMaxWidth: 720,
    formFieldMinWidth: 200,
    formFieldMaxWidth: 480,
};
/**
 * KIRILIM ARİTMETİĞİ — Revizyon 2'nin `bpOf/padOf/gapOf` fonksiyonlarının
 * birebir karşılığı. Web rayına bağlı olanlar (`railOf`, `midOf`, dizinin
 * `midFor`u) `web-tema/yerlesim.ts`e taşındı (R turu, 29.10.2026).
 *
 * Hem kapı testi hem kanıt koşumu buradan okur: "sözleşme ne diyor" sorusunun
 * TEK cevabı olsun ve tabloya yazılan sayı ile CSS'e basılan sayı ayrışmasın.
 */
export function breakpointOf(width) {
    if (width < breakpoints.md)
        return 'sm';
    if (width < breakpoints.l)
        return 'md';
    if (width < breakpoints.xl)
        return 'l';
    if (width < breakpoints.xxl)
        return 'xl';
    return 'xxl';
}
/** `padOf(w)` — merdivenin o genişlikteki basamağı. */
export function gutterFor(width) {
    let value = layout.gutterLadder[0].padding;
    for (const step of layout.gutterLadder) {
        if (width >= step.minWidth)
            value = step.padding;
    }
    return value;
}
/** `gapOf(w)` — kolon arası merdiveninin o genişlikteki basamağı. */
export function columnGapFor(width) {
    let value = layout.gapLadder[0].gap;
    for (const step of layout.gapLadder) {
        if (width >= step.minWidth)
            value = step.gap;
    }
    return value;
}
//# sourceMappingURL=layout.js.map